// Models
import { FormFieldSchema } from 'app/shared/models/form';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

// Constants
import { CURRENCY_CODE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/currencyCodes';
import { required } from 'app/shared/utils/validation';

export const FROM_FOREIGN_CURRENCY_CODE: FormFieldSchema<string> = {
  label: 'Foreign currency',
  name: 'foreign_currency_code',
  default: '',
  required: true,
  validate: required('Foreign Currency is required.'),
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    options: CURRENCY_CODE_OPTIONS,
  },
};

export const FROM_FOREIGN_CURRENCY_AMOUNT: FormFieldSchema<string> = {
  label: 'Foreign currency amount',
  name: 'foreign_amount',
  default: '',
  required: true,
  validate: required('Foreign Currency Amount is required.'),
  type: U21FormFieldTypes.TEXT,
};

export const FROM_FOREIGN_EXCHANGE_RATE: FormFieldSchema<string> = {
  label: 'Exchange rate',
  name: 'foreign_exchange_rate',
  default: '',
  required: true,
  validate: required('Exchange Rate is required.'),
  type: U21FormFieldTypes.TEXT,
};

export const FOREIGN_CURRENCY_SCHEMA = [
  FROM_FOREIGN_CURRENCY_CODE,
  FROM_FOREIGN_CURRENCY_AMOUNT,
  FROM_FOREIGN_EXCHANGE_RATE,
];
